<template>
  <v-card-title v-if="event && race" class="subtitle result--filter">  
    <span v-if="showRace && (races.length <= 1 || !showRaceDropdown)">{{ race.name }}</span>
    <v-select 
      v-else-if="showRace"
      :items="races" 
      item-text="name" 
      item-value="id" 
      v-model="raceId" 
      hide-details
      solo
      rounded
      style="max-width:250px" 
      class="mr-4 mt-0 pt-0 d-inline-block" 
      @change="$router.push({ name: 'race', params: { id: event.id, raceId: raceId} })"
      />
    <v-spacer v-if="showRace"/>
    <v-btn-toggle v-if="true && meta && meta.has_genders && !race.team" v-model="gender" @change="search" class="result-filter--gender">
      <v-btn text value="*" :small="$vuetify.breakpoint.xs">
        {{$t('shared.gender-all')}}
      </v-btn>
      <v-btn value="F" :title="$t('shared.gender-female')" :small="$vuetify.breakpoint.xs">
        {{$t('shared.gender-female')}}
      </v-btn>
      <v-btn value="M" :title="$t('shared.gender-male')" :small="$vuetify.breakpoint.xs">
        {{$t('shared.gender-male')}}
      </v-btn>
    </v-btn-toggle>
    <v-btn-toggle v-if="true && race.team && race.team_gender_results" v-model="gender" @change="search" class="result-filter--gender">
      <v-btn text value="*" :small="$vuetify.breakpoint.xs">
        {{$t('shared.gender-all')}}
      </v-btn>
      <v-btn value="F" :title="$t('shared.gender-female')" :small="$vuetify.breakpoint.xs">
        {{$t('shared.gender-female')}}
      </v-btn>
      <v-btn value="M" :title="$t('shared.gender-male')" :small="$vuetify.breakpoint.xs">
        {{$t('shared.gender-male')}}
      </v-btn>
      <v-btn v-if="race.team_gender_results == 'M_F_MIX'" text value="mix" :title="$t('events.race.filter-team-mixed')" :small="$vuetify.breakpoint.xs">
        {{$t('shared.gender-mix')}}
      </v-btn>
    </v-btn-toggle>
    <v-spacer/>
    <v-select 
      v-if="true && meta && meta.categories && meta.categories.length > 0" 
      v-model="category" 
      :items="categoryList"
      solo
      rounded
      clearable
      hide-details
       :small="$vuetify.breakpoint.xs"
      :placeholder="$t('events.race.category')"
      :class="`result-filter--category ${ $vuetify.breakpoint.xs ? 'small' : ''}`" 
      @change="search">
    </v-select>
    <v-spacer/>
    <v-text-field 
      v-model="resultSearch" 
      solo 
      rounded 
      clearable 
      hide-details 
      v-on:keyup.enter="search" 
      @click:clear="resultSearch='';search()" 
      @click:prepend="search" 
      prepend-icon="fa-search" 
      :class="`result-filter--search ${ $vuetify.breakpoint.xs ? 'small' : ''}`" 
      :placeholder="race.team ? $t('events.race.search-team-or-member') : $t('events.race.search-participant')" 
    />
    <v-switch 
      v-if="race.type === 'HYBRID' && !race.team" 
      v-model="onlyOfficialResults" 
      :label="$t('events.race.filter-official-only')" 
      class="full-flex-row"
      hide-details 
      @change="search"
      />
  </v-card-title>
</template>

<script>

export default {
  name: "RaceResultFilter",
  components: {
  },
  props: {
      title: String,
      meta: Object,
      event: Object,
      race: Object,
      filter: Object,
      showRace: {
        type: Boolean,
        default: true,
      },
      showRaceDropdown: {
        type: Boolean,
        default: true,
      },
  },
  data() {
    return {
      gender: '*',
      onlyOfficialResults: false,
      category: null,
      resultSearch: null,
      raceId: null,
      races: [],
    };
  },
  async mounted() {
    this.races = this.event.races;
    this.raceId = this.race.id;
    if (this.filter) {
      this.loadFilter(this.filter);
    }
  },
  methods: {
    async loadFilter(filter) {
      this.resultSearch = filter.search;
      this.category = filter.category;
      this.gender = filter.gender;
      this.onlyOfficialResults = filter.onlyOfficialResults;
    },

    async search() {
      console.log('Search filter updating...');
      this.$emit('change', { 
        search: this.resultSearch, 
        onlyOfficialResults: this.onlyOfficialResults, 
        category: this.category == 'All' ? null : this.category, 
        gender: this.gender == '*' ? null : this.gender 
      });
    },
  },
  computed: {
    categoryList() {
      return this.meta.categories ? ['All'].concat(this.meta.categories) : [];
    },
    isEmbedded() {
      return this.$route.query.view === 'embed' || this.$store.state.view == 'embed';
    },
  },
  watch: {
    race() {
      this.raceId = this.race.id;
    },
  }

};
</script>
<style lang="scss">
.result-filter--gender {  }
.result-filter--category { max-width: 180px; float: right; }

.result-filter--search { max-width: 350px; float: right; }
.result-filter--search.small { max-width: 100%; margin-top: 10px; }
.v-text-field--rounded.small .v-input__prepend-outer { margin-top: 4px !important; }
.v-text-field--rounded.small .v-input__control { min-height: 36px !important; }
.v-text-field--rounded.small input { padding: 0 !important; }

.full-flex-row { flex-basis: 100% !important;}

</style>

